import { render, staticRenderFns } from "./winDialog.vue?vue&type=template&id=b81500de&scoped=true"
import script from "./winDialog.vue?vue&type=script&lang=ts"
export * from "./winDialog.vue?vue&type=script&lang=ts"
import style0 from "./winDialog.vue?vue&type=style&index=0&id=b81500de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81500de",
  null
  
)

export default component.exports